import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { I18nProvider } from '@upweo/ui';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { App } from './App.js';
import { ApiClientError } from './lib/api-client.js';
import { PartnerProvider } from './lib/partner-provider.js';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: (failureCount, error) => {
        // Auth and permission failures will not resolve by trying again.
        if (error instanceof ApiClientError && error.status >= 400 && error.status < 500) {
          return false;
        }
        return failureCount < 2;
      },
    },
  },
});

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element #root not found in index.html');
}

createRoot(container).render(
  <StrictMode>
    <I18nProvider storageKey="upweo_partner_locale">
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <PartnerProvider>
            <App />
          </PartnerProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </I18nProvider>
  </StrictMode>,
);
